import { OidcAccessToken } from '@ori/auth';

export const getPublicToken = async () => {
  if (window.ori?.tokenService) {
    const oriToken = await window.ori.tokenService.getPublicToken();
    if (oriToken) {
      return new OidcAccessToken(oriToken.Token);
    }
  }

  return undefined;
};
